import React, { useState,useEffect } from "react";
import {
  DialogContent,
  CardContent,
  Card,
  makeStyles,
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import {fetchReEnqireData} from '../../../shared/api/purple/outbondPayment'
import JSONPretty from 'react-json-pretty';

export const ReEnqireModal = (props) => {
  const { visible, handleDialogClose} = props;
  const [reEnqireModalData ,setReEnqireModalData]= useState()

  const useStyle = makeStyles((theme) => ({
    table: {
      marginBottom: "1rem",
    },
    card: {
      "& .MuiCardHeader-root": {
        padding: "12px",
        paddingBottom: 0,
      },
      "& .MuiCardContent-root": {
        padding: 0,
      },
    },
  }));
  const classes = useStyle();

  const handleClose = () => {
    handleDialogClose(false);
  };


  const ReEnqiretData = {
    "outbound_reference_number":props.data.outbound_reference_number
  }
  const fetchReEnqiretData = async () =>{
    fetchReEnqireData(ReEnqiretData)
    .then((res) =>{
      if(res.message === "Success")
      {
        setReEnqireModalData(res.data)
      }
    })
  }

  useEffect(() =>{
    fetchReEnqiretData()
    // eslint-disable-next-line
  },[])

  let responceData;
  if(reEnqireModalData?.length === 0){
    responceData = "No Data Found"
  } else {
    responceData = JSON.stringify(reEnqireModalData);
  }
  

  return (
    <Spin >
      <KisshtDialog
        title="Enquire API Response"
        maxWidth={"sm"}
        open={visible}
        handleClose={handleClose}
      >
        <DialogContent>
          <Card className={classes.card}>
            <CardContent>
                <p><JSONPretty id="json-pretty" data={responceData}></JSONPretty></p>
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};
export default ReEnqireModal;